import { render, staticRenderFns } from "./ModalAssinaturaSignatario.vue?vue&type=template&id=91fc0410"
import script from "./ModalAssinaturaSignatario.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaSignatario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports